import { Box, HStack, Skeleton, VStack } from "@chakra-ui/react-v3";

/**
 * Skeleton loader for patient overview content.
 * Shows AI summary card and a table section.
 */
export function ContentLoadingSkeleton() {
  return (
    <Box backgroundColor="bg.canvas">
      <VStack align="stretch" gap={4}>
        {/* AI Summary Card Skeleton */}
        <Box
          borderRadius="lg"
          bg="bg.surface"
          px={6}
          py={5}
          border="1px"
          borderColor="border"
          boxShadow="sm"
        >
          <Skeleton height="14px" width="100px" mb={3} />
          <VStack align="stretch" gap={1}>
            <Skeleton height="14px" width="100%" />
            <Skeleton height="14px" width="100%" />
            <Skeleton height="14px" width="95%" />
            <Skeleton height="14px" width="60%" />
          </VStack>
        </Box>

        {/* Table Section Skeleton */}
        <Box
          borderRadius="lg"
          bg="bg.surface"
          px={6}
          py={6}
          border="1px"
          borderColor="border"
          boxShadow="sm"
        >
          {/* Table Title + Filter Button */}
          <HStack justify="space-between" mb={6}>
            <Skeleton height="32px" width="120px" />
            <Skeleton height="32px" width="70px" borderRadius="md" />
          </HStack>

          {/* Table Header Row - solid bar without skeleton elements */}
          <Box height="40px" bg="bg.canvas" borderTopRadius="md" />

          {/* Table Rows */}
          <VStack align="stretch" mt={3} gap={0}>
            {[1, 2, 3, 4, 5].map(i => (
              <HStack key={i} gap={4} py={1} px={4} borderBottom="1px" borderColor="border.subtle">
                <Skeleton height="24px" width="40%" />
                <Skeleton height="24px" width="25%" />
                <Skeleton height="24px" width="30%" />
              </HStack>
            ))}
          </VStack>
        </Box>

        {/* Table Section Skeleton */}
        <Box
          borderRadius="lg"
          bg="bg.surface"
          px={6}
          py={6}
          border="1px"
          borderColor="border"
          boxShadow="sm"
        >
          {/* Table Title + Filter Button */}
          <HStack justify="space-between" mb={6}>
            <Skeleton height="32px" width="120px" />
            <Skeleton height="32px" width="70px" borderRadius="md" />
          </HStack>

          {/* Table Header Row - solid bar without skeleton elements */}
          <Box height="40px" bg="bg.canvas" borderTopRadius="md" />

          {/* Table Rows */}
          <VStack align="stretch" mt={3} gap={0}>
            {[1, 2, 3, 4, 5].map(i => (
              <HStack key={i} gap={4} py={1} px={4} borderBottom="1px" borderColor="border.subtle">
                <Skeleton height="24px" width="40%" />
                <Skeleton height="24px" width="25%" />
                <Skeleton height="24px" width="30%" />
              </HStack>
            ))}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
}
